<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M25.302 15.876a9.426 9.426 0 01-9.426 9.426 9.426 9.426 0 119.426-9.426zM15.079 18.75h-1.364v-1.355H10.94v-1.15l1.606-3.945h1.512L12.5 16.16h1.216v-1.39h1.364v1.392h.687v1.234h-.687v1.355zm5.958-4.91l-1.67 2.334 1.645 2.463H19.39l-.863-1.273-.777 1.278h-1.56l1.595-2.384-1.595-2.419h1.635l.82 1.253.83-1.253h1.562z"/></svg>